import { RecomendationsGeneral } from './RecomendationsGeneral';

export default RecomendationsGeneral;